export default __webpack_public_path__ + "static/media/AddAccount2.1ab3c65d.svg";